import { ReactNode } from "react";
import { useFormContext, UseFormMethods } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { get } from "lodash";
import { ChakraProps } from "@chakra-ui/system/dist/types/system.types";
import { Box } from "@chakra-ui/react";

import { IChildrenAsFunction } from "types/IChildrenAsFunction";

import { ChakraText } from "../ChakraText";
import { RedText } from "./RedText";

interface IProps extends ChakraProps {
  name: string;
  children: IChildrenAsFunction<{ methods: UseFormMethods; hasError: boolean }>;
  label?: ReactNode;
  isRequired?: boolean;
}

const FieldPrototype = ({
  name,
  label,
  isRequired,
  children,
  ...boxProps
}: IProps) => {
  const methods = useFormContext();
  const hasError = Boolean(get(methods.errors, name));
  return (
    <Box {...boxProps}>
      {label && (
        <label htmlFor={name}>
          {hasError ? (
            <RedText d="inline">{label}</RedText>
          ) : (
            <ChakraText d="inline">{label}</ChakraText>
          )}{" "}
          {isRequired ? <RedText d="inline">*</RedText> : null}
        </label>
      )}
      {children({ methods, hasError })}
      <ErrorMessage
        errors={methods.errors}
        name={name}
        render={({ message }) => {
          return <RedText>{message}</RedText>;
        }}
      />
    </Box>
  );
};

export { FieldPrototype };
